module.exports = __webpack_public_path__ + "img/momo_button_point_record.6ae8ff79.png";